import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required, numeric } from 'vuelidate/lib/validators';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { Getter } from 'vuex-class';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import BaseDateTimeField from '@/components/datetime_field/Index.vue';
import DateMixin from '@/helpers/mixins/DateMixin';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import BaseTimePicker from '@/components/timepicker/Index.vue';
import moment from 'moment';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let AutomaticDiscountForm = class AutomaticDiscountForm extends mixins(FormMixin, DateMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.date = null;
        this.form = {
            name: null,
            value: null,
            startAt: null,
            endAt: null,
            usageLimit: null,
            startAtTime: null,
            endAtTime: null,
            active: true,
            discountType: 'absolute',
            oneTime: false,
        };
        this.durationTrigger = false;
        this.openStartDateModal = false;
        this.openEndDateModal = false;
        this.openStartTimeModal = false;
        this.openEndTimeModal = false;
    }
    get title() {
        return this.update ? 'Edit Discount' : 'Add Discount';
    }
    isChecked(value) {
        return this.$v?.form?.discountType?.$model === value;
    }
    get action() {
        return this.update ? 'Edit' : 'Create';
    }
    get discountTypes() {
        return [
            selectOptionBuilder('absolute', 'Absolute'),
            selectOptionBuilder('percentage', 'Percentage'),
        ];
    }
    get discountTypeIsPercentage() {
        return this.$v.form.discountType.$model === 'percentage';
    }
    resetDiscountValue() {
        this.$v.form.value.$model = null;
    }
    get minEndAtDate() {
        const startDate = new Date(this.form.startAt);
        const minDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 2);
        return moment(minDate).format('YYYY-MM-DD');
    }
    get codeErrors() {
        const errors = [];
        if (!this.$v.form.name.$dirty) {
            return errors;
        }
        if (!this.$v.form.name.required) {
            const msg = requiredProperty('Discount Name');
            errors.push(msg);
        }
        return errors;
    }
    get valueErrors() {
        const errors = [];
        if (!this.$v.form.value.$dirty) {
            return errors;
        }
        if (!this.$v.form.value.required) {
            const msg = requiredProperty('Value');
            errors.push(msg);
        }
        return errors;
    }
    get discountTypeErrors() {
        const errors = [];
        if (!this.$v.form.discountType.$dirty) {
            return errors;
        }
        if (!this.$v.form.discountType.required) {
            const msg = requiredProperty('Discount Type');
            errors.push(msg);
        }
        return errors;
    }
    get usageLimitErrors() {
        const errors = [];
        if (!this.$v.form.usageLimit.$dirty) {
            return errors;
        }
        if (!this.$v.form.usageLimit.required) {
            const msg = requiredProperty('Usage Limit');
            errors.push(msg);
        }
        return errors;
    }
    get endAtErrors() {
        const errors = [];
        if (!this.$v.form.endAt.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAt.required) {
            const msg = requiredProperty('End Date');
            errors.push(msg);
        }
        if (!this.$v.form.endAt.mustBeAfterStartDate) {
            errors.push('End Date should be after Start Date');
        }
        return errors;
    }
    get endTimeErrors() {
        const errors = [];
        if (!this.$v.form.endAtTime.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAtTime.required) {
            const msg = requiredProperty('End Time');
            errors.push(msg);
        }
        return errors;
    }
    get startTimeErrors() {
        const errors = [];
        if (!this.$v.form.startAtTime.$dirty) {
            return errors;
        }
        if (!this.$v.form.startAtTime.required) {
            const msg = requiredProperty('Start Time');
            errors.push(msg);
        }
        return errors;
    }
    get startAtErrors() {
        const errors = [];
        if (!this.$v.form.startAt.$dirty) {
            return errors;
        }
        if (!this.$v.form.startAt.required) {
            const msg = requiredProperty('Start Date');
            errors.push(msg);
        }
        return errors;
    }
    get startDateError() {
        if (this.durationTrigger && !this.form.startAt) {
            if (this.form.startAtTime || this.form.endAt || this.form.endAtTime) {
                return ['Start Date is required'];
            }
        }
        return [];
    }
    get endDateError() {
        if (this.durationTrigger && !this.form.endAt) {
            if (this.form.startAtTime || this.form.startAt || this.form.endAtTime) {
                return ['End Date is required'];
            }
        }
        return [];
    }
    get startAtTimeError() {
        if (this.durationTrigger && !this.form.startAtTime) {
            if (this.form.endAtTime || this.form.startAt || this.form.endAt) {
                return ['Start Time is required'];
            }
        }
        return [];
    }
    get endAtTimeError() {
        if (this.durationTrigger && !this.form.endAtTime) {
            if (this.form.startAtTime || this.form.startAt || this.form.endAt) {
                return ['End Time is required'];
            }
        }
        return [];
    }
    onSubmit() {
        this.durationTrigger = true;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.$emit('submit', this.form);
        }
    }
    handleCancelClick() {
        localStorage.setItem('tab', '1');
        this.$router.push({ name: 'ecommerce-promos' });
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
        }
    }
    get startAtFilled() {
        this.durationTrigger = false;
        return !!this.$v.form?.startAt?.$model;
    }
    onStartDateChange() {
        this.$nextTick(() => {
            this.startAtFilled;
        });
    }
    get endAtFilled() {
        return !!this.$v.form?.endAt?.$model;
    }
    onEndDateChange() {
        this.$nextTick(() => {
            this.endAtFilled;
        });
    }
    clearStartAt() {
        if (this.$v?.form?.startAt) {
            this.$v.form.startAt.$model = null;
        }
    }
    clearStartAtTime() {
        if (this.$v?.form?.startAtTime) {
            this.$v.form.startAtTime.$model = null;
        }
    }
    clearEndAt() {
        if (this.$v?.form?.endAt) {
            this.$v.form.endAt.$model = null;
        }
    }
    clearEndAtTime() {
        if (this.$v?.form?.endAtTime) {
            this.$v.form.endAtTime.$model = null;
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], AutomaticDiscountForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AutomaticDiscountForm.prototype, "update", void 0);
__decorate([
    Prop({ type: Object, default: null })
], AutomaticDiscountForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AutomaticDiscountForm.prototype, "disabled", void 0);
AutomaticDiscountForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            NumericInput,
            BaseTextField,
            BaseDateTimeField,
            BaseDatePicker,
            BaseTimePicker,
        },
        validations: {
            form: {
                name: {
                    required,
                },
                value: {
                    numeric,
                    required,
                },
                usageLimit: {
                    numeric,
                },
                discountType: {
                    required,
                },
                startAt: {},
                endAt: {
                    required() {
                        const { startAt, endAt } = this.form;
                        return !startAt || !!endAt;
                    },
                    mustBeAfterStartDate() {
                        const startDate = this.form.startAt;
                        const endDate = this.form.endAt;
                        if (!startDate) {
                            return true;
                        }
                        const parsedStartDate = new Date(startDate);
                        const parsedEndDate = new Date(endDate);
                        return parsedEndDate > parsedStartDate;
                    },
                },
                startAtTime: {
                    required() {
                        const { startAt, startAtTime } = this.form;
                        return !startAt || !!startAtTime;
                    },
                },
                endAtTime: {
                    required() {
                        const { startAt, endAtTime } = this.form;
                        return !startAt || !!endAtTime;
                    },
                },
                oneTime: {
                    required,
                },
            },
        },
    })
], AutomaticDiscountForm);
export default AutomaticDiscountForm;
